<app-back-button />

<header>
  <h1>{{ 'admin.title' | translate }}</h1>
</header>

<a mat-stroked-button color="primary" [routerLink]="['/', 'users']" class="user-management-link">
  <mat-icon svgIcon="user" />
  {{ 'admin.user-management.title' | translate }}
</a>

<section>
  <header>
    <h2>{{ 'admin.sharepoint-templates.title' | translate }}</h2>
  </header>

  <div class="admin-action-item-list">
    <div class="admin-action-item">
      <div>
        <h3>{{ 'admin.sharepoint-templates.customer-space-template' | translate }}</h3>
        <small>
          {{
            'admin.sharepoint-templates.last-refreshed'
              | translate
                : {
                    lastUpdate: latestTemplateUpdates()?.latestCustomerSpaceTemplateActualisation | date: 'dd.MM.yyyy HH:mm:ss'
                  }
          }}
        </small>
      </div>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.sharepoint-templates.refresh-now' | translate"
        [matTooltip]="'admin.sharepoint-templates.refresh-now' | translate"
        [appLoadingButton]="extractPending()"
        (click)="extractCustomerSpaceTemplate()"
      >
        <mat-icon svgIcon="reload" />
      </button>
    </div>

    <div class="admin-action-item">
      <div>
        <h3>{{ 'admin.sharepoint-templates.project-template' | translate }}</h3>
        <small>
          {{
            'admin.sharepoint-templates.last-refreshed'
              | translate: { lastUpdate: latestTemplateUpdates()?.latestProjectTemplateActualisation | date: 'dd.MM.yyyy HH:mm:ss' }
          }}
        </small>
      </div>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.sharepoint-templates.refresh-now' | translate"
        [matTooltip]="'admin.sharepoint-templates.refresh-now' | translate"
        [appLoadingButton]="extractPending()"
        (click)="extractProjectTemplate()"
      >
        <mat-icon svgIcon="reload" />
      </button>
    </div>
  </div>
</section>

<section>
  <header>
    <h2>{{ 'admin.reports.title' | translate }}</h2>
  </header>

  <div class="admin-action-item-list">
    <div class="admin-action-item">
      <h3>{{ 'admin.reports.customer-space-report' | translate }}</h3>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.reports.download' | translate"
        [matTooltip]="'admin.reports.download' | translate"
        [appLoadingButton]="customerSpaceReportPending.isPending()"
        (click)="downloadCustomerSpaceReport()"
      >
        <mat-icon svgIcon="download" />
      </button>
    </div>

    <div class="admin-action-item">
      <h3>{{ 'admin.reports.project-report' | translate }}</h3>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.reports.download' | translate"
        [matTooltip]="'admin.reports.download' | translate"
        [appLoadingButton]="projectReportPending.isPending()"
        (click)="downloadProjectReport()"
      >
        <mat-icon svgIcon="download" />
      </button>
    </div>

    <div class="admin-action-item">
      <h3>{{ 'admin.reports.user-report' | translate }}</h3>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.reports.download' | translate"
        [matTooltip]="'admin.reports.download' | translate"
        [appLoadingButton]="userReportPending.isPending()"
        (click)="downloadUserReport()"
      >
        <mat-icon svgIcon="download" />
      </button>
    </div>
  </div>
</section>

<section>
  <header>
    <h2>{{ 'admin.reports.charging-report' | translate }}</h2>
  </header>

  <div class="admin-action-item-list">
    <form [formGroup]="chargingReportForm" (ngSubmit)="downloadChargingReport()" class="admin-action-item">
      <div>
        <h3>{{ 'admin.reports.charging-report' | translate }}</h3>

        <mat-form-field subscriptSizing="dynamic">
          <mat-label>{{ 'admin.reports.period' | translate }}</mat-label>
          <mat-date-range-input [formGroup]="chargingReportForm" [rangePicker]="picker">
            <input matStartDate formControlName="periodStartDate" placeholder="{{ 'admin.reports.period-start-date' | translate }}" />
            <input matEndDate formControlName="periodEndDate" placeholder="{{ 'admin.reports.period-end-date' | translate }}" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error
            *ngIf="
              chargingReportForm.get('periodStartDate')?.hasError('matDatepickerParse') ||
              chargingReportForm.get('periodStartDate')?.hasError('matStartDateInvalid') ||
              chargingReportForm.get('periodEndDate')?.hasError('matDatepickerParse') ||
              chargingReportForm.get('periodEndDate')?.hasError('matEndDateInvalid')
            "
          >
            {{ 'admin.reports.date-invalid' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              chargingReportForm.get('periodStartDate')?.hasError('required') ||
              chargingReportForm.get('periodEndDate')?.hasError('required')
            "
          >
            {{ 'admin.reports.date-required' | translate }}
          </mat-error>
        </mat-form-field>
      </div>

      <button
        mat-icon-button
        color="primary"
        type="submit"
        [attr.aria-label]="'admin.reports.download' | translate"
        [matTooltip]="'admin.reports.download' | translate"
        [appLoadingButton]="chargingReportPending.isPending()"
      >
        <mat-icon svgIcon="download" />
      </button>
    </form>

    <div class="admin-action-item">
      <h3>{{ 'admin.reports.file-process-report' | translate }}</h3>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.reports.download' | translate"
        [matTooltip]="'admin.reports.download' | translate"
        [appLoadingButton]="fileProcessReportPending.isPending()"
        (click)="downloadFileProcessReport()"
      >
        <mat-icon svgIcon="download" />
      </button>
    </div>
  </div>
</section>

<section>
  <header>
    <h2>{{ 'admin.batch-creation.customer-spaces' | translate }}</h2>
  </header>

  <div class="admin-action-item-list">
    <div class="admin-action-item">
      <h3>{{ 'admin.batch-creation.upload-file' | translate }}</h3>
      <button
        mat-icon-button
        color="primary"
        [attr.aria-label]="'admin.batch-creation.upload-file' | translate"
        [matTooltip]="'admin.batch-creation.upload-file' | translate"
        (click)="openFileUploadDialog()"
      >
        <mat-icon svgIcon="upload" />
      </button>
    </div>
  </div>
</section>
